// extracted by mini-css-extract-plugin
module.exports = {"headColumn":"CmsLargeAssetCenteredHero_headColumn__x8pHL","headColumn__stack":"CmsLargeAssetCenteredHero_headColumn__stack__JNfWa"};